/* AROL · enlaces reales como respaldo; diálogo accesible solo si JavaScript carga. */
(function () {
  'use strict';
  var overlay, opener;
  function focusables() { return Array.from(overlay.querySelectorAll('a[href],button:not([disabled])')); }
  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;document.body.classList.remove('arol-contact-is-open');
    if (opener) { opener.setAttribute('aria-expanded','false');if (opener.isConnected) opener.focus(); }
  }
  function initialize() {
    if (overlay && !overlay.hidden) close();
    overlay = document.getElementById('arol-contact-overlay');
    if (!overlay) return;
    document.querySelectorAll('[data-arol-contact-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-controls',overlay.id);trigger.setAttribute('aria-expanded','false');
    });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-arol-contact-open]');
    if (trigger && overlay) {
      event.preventDefault();opener = trigger;overlay.hidden = false;
      trigger.setAttribute('aria-expanded','true');document.body.classList.add('arol-contact-is-open');
      overlay.querySelector('[data-arol-contact-close]').focus();return;
    }
    if (!overlay || overlay.hidden) return;
    if (event.target === overlay || event.target.closest('[data-arol-contact-close]') || event.target.closest('#arol-contact-overlay a[href]')) close();
  });
  document.addEventListener('keydown', function (event) {
    if (!overlay || overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault();event.stopPropagation();close();return; }
    if (event.key !== 'Tab') return;
    var items = focusables(), first = items[0], last = items[items.length-1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
